// src/js/components/megamenu.js
if (!customElements.get("main-megamenu")) {
  class MainMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        listButton: "[megamenu-hover-item]",
        listContainer: "[megamenu-hover-object]"
      };
      this.prevEle = this.querySelector(`${this.selectors.listButton}.active`);
      this.init();
    }
    init() {
      this.listButtons = this.querySelectorAll(this.selectors.listButton);
      this.listButtons.forEach((button) => {
        button.addEventListener("mouseenter", this.handleMouseEnter.bind(this));
      });
      const details = this.closest("details");
      if (details) {
        details.addEventListener("toggle", this.handleDetailsToggle.bind(this));
      }
    }
    handleDetailsToggle(event) {
      if (!event.target.open) return;
      const activeContainer = this.querySelector(`${this.selectors.listContainer}.active`);
      if (activeContainer) {
        this.loadProducts(activeContainer);
      }
    }
    handleMouseEnter(event) {
      if (this.prevEle && this.prevEle !== event.target) {
        const datasetId = event.target.dataset.id;
        const listContainer = this.querySelector(`${this.selectors.listContainer}[data-id="${datasetId}"]`);
        if (listContainer && !listContainer.classList.contains("active")) {
          listContainer.classList.add("active");
          event.target.classList.add("active");
          this.loadProducts(listContainer);
        }
        this.handleMouseLeave(this.prevEle);
      }
      this.prevEle = event.target;
    }
    handleMouseLeave(ele) {
      const datasetId = ele.dataset.id;
      const listContainer = this.querySelector(`${this.selectors.listContainer}[data-id="${datasetId}"]`);
      if (listContainer && listContainer.classList.contains("active")) {
        listContainer.classList.remove("active");
        ele.classList.remove("active");
      }
    }
    loadProducts(container) {
      if (container.dataset.loaded) return;
      const collectionUrl = container.dataset.collectionUrl;
      if (!collectionUrl) return;
      fetch(`${collectionUrl}?section_id=megamenu-products`).then((response) => response.text()).then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const section = html.querySelector(".shopify-section");
        if (section?.innerHTML.trim()) {
          container.innerHTML = section.innerHTML;
        }
        container.dataset.loaded = "true";
      }).catch((error) => {
        console.error("Megamenu product load error:", error);
      });
    }
  }
  customElements.define("main-megamenu", MainMegaMenu);
}
if (!customElements.get("header-megamenu")) {
  class HeaderMegamenu extends HTMLElement {
    constructor() {
      super();
      this.megamenuSelectors = {
        megamenu: "[megamenu-opener]",
        megamenuLinks: "[megamenu-items-link]",
        megamenuBtn: "[megamenu-btn]"
      };
      this.prevMenu = "";
      this.megamenu = this.querySelectorAll(this.megamenuSelectors.megamenu);
      this.megamenuLinks = this.querySelectorAll(this.megamenuSelectors.megamenuLinks);
      this.megamenuBtns = this.querySelectorAll(this.megamenuSelectors.megamenuBtn);
      this.megamenuBtns.forEach((megamenuBtn) => {
        const details = megamenuBtn.parentElement;
        details.addEventListener("toggle", () => {
          megamenuBtn.setAttribute("aria-expanded", details.open);
        });
        megamenuBtn.setAttribute("aria-expanded", details.open);
      });
      this.megamenu.forEach((menu) => {
        let mouseLeaveTimeout;
        let mouseEnterTimeout;
        menu?.addEventListener("mouseenter", () => {
          const megamenuInner = menu?.querySelector("[megamenu-content]");
          const megamenuBtn = menu?.querySelector("[megamenu-btn]");
          document.body.classList.add("has-active-modal");
          let expanded = false;
          this.megamenuBtns.forEach((megamenuBtn2) => {
            if (megamenuBtn2.parentElement.open) {
              expanded = true;
            }
            this.closeMenu(megamenuBtn2);
          });
          if (megamenuInner && megamenuBtn) {
            clearTimeout(mouseLeaveTimeout);
            if (expanded == false) {
              mouseEnterTimeout = setTimeout(() => {
                this.openMenu(megamenuBtn);
              }, 200);
            } else {
              this.openMenu(megamenuBtn);
            }
          }
        });
        menu.addEventListener("mouseleave", () => {
          const megamenuInner = menu?.querySelector("[megamenu-content]");
          const megamenuBtn = menu?.querySelector("[megamenu-btn]");
          document.body.classList.remove("has-active-modal");
          if (megamenuInner && megamenuBtn) {
            clearTimeout(mouseEnterTimeout);
            if (megamenuBtn.parentElement.open) {
              mouseLeaveTimeout = setTimeout(() => {
                this.closeMenu(megamenuBtn);
              }, 300);
            }
          }
        });
      });
    }
    closeMenu(megamenuBtn) {
      megamenuBtn.parentElement.removeAttribute("open");
    }
    openMenu(megamenuBtn) {
      megamenuBtn.parentElement.setAttribute("open", "");
    }
  }
  customElements.define("header-megamenu", HeaderMegamenu);
}
